import { render } from "./Details.vue?vue&type=template&id=e1188dac&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=e1188dac&lang=less&scoped=true"

import exportComponent from "C:\\Users\\shuang\\Documents\\单子\\后台管理系统\\zy_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1188dac"]])

export default __exports__